// extracted by mini-css-extract-plugin
export default {"app":"App_app__GuJBs","toast":"App_toast__t-Iuz"};